let observer;

export function startObserver(observeCallback) {
  const target = document.getElementById('__next');
  const config = {
    childList: true,
    subtree: true,
  };
  observer = new MutationObserver(observeCallback);
  observer.observe(target, config)
}

export function stopObserver() {
  if (observer && observer instanceof MutationObserver) {
    observer.disconnect()
    observer = null
  }
}
